import React from 'react';
import DashboardLayout from '../layout/DashboardLayout';

const TimeManagement = () => {
  return (
    <DashboardLayout>
      <div className="p-4">
        <h1 className="text-2xl font-bold">HR/Time Management</h1>
        <p>Coming soon...</p>
      </div>
    </DashboardLayout>
  );
};

export default TimeManagement; 